// Makes localStorage "seen" flags reactive for the tab-interest 'new' dots.
// Opening a sub-tab marks its own flag and bumps seenVersion, which the navbars
// and submenu depend on so the corresponding dot (and the aggregated parent dot)
// clear immediately.
import { writable } from 'svelte/store';

export const seenVersion = writable(0);

// Mark a single "seen" flag and bump the reactive version. Called when the user
// opens the sub-tab that owns the flag (e.g. Card Collection / Divided Nation).
export function markSeenFlag(key) {
    if (localStorage.getItem(key) !== 'true') {
        localStorage.setItem(key, 'true');
        seenVersion.update((v) => v + 1);
    }
}

export function readSeenFlags() {
    return {
        cardCollectionSeen: localStorage.getItem('cardCollectionSeen'),
        dividedNationSeen: localStorage.getItem('dividedNationSeen'),
        chainDealsSeen: localStorage.getItem('chainDealsSeen'),
        singleJackFeverSeen: localStorage.getItem('singleJackFeverSeen'),
    };
}
